import GlassCard from "@/v2/components/GlassCard";
import { Clock, CheckCircle2, AlertTriangle } from "lucide-react";

export default function SprintHeader({
  tier,
  status,
  daysRemaining,
  dayNumber,
  totalDays,
  readOnly,
  isCompleted,
  isExpired,
  hasExpiry,
}: {
  tier: "self_service" | "with_call";
  status: string;
  daysRemaining: number | null;
  dayNumber: number | null;
  totalDays: number;
  readOnly: boolean;
  isCompleted: boolean;
  isExpired: boolean;
  hasExpiry: boolean;
}) {
  const renderTimeLine = () => {
    if (isCompleted) return <span>Sprint completato</span>;
    if (isExpired) return <span>Sprint scaduto</span>;
    if (dayNumber != null && hasExpiry) {
      return (
        <span>
          Giorno {dayNumber} di {totalDays}
          {daysRemaining != null && (
            <span className="text-slate-400"> · {daysRemaining} giorni rimasti</span>
          )}
        </span>
      );
    }
    if (!hasExpiry) {
      return (
        <span>
          Sprint attivo
          <span className="text-slate-500"> · scadenza non impostata</span>
        </span>
      );
    }
    return <span>Sprint attivo</span>;
  };

  return (
    <GlassCard className="!p-5 md:!p-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-xs uppercase tracking-widest text-secondary">Il mio Sprint</p>
          <h1 className="text-2xl md:text-3xl font-bold mt-1">
            7 giorni per testare davvero
          </h1>
          <div className="flex items-center gap-2 mt-2 text-sm text-slate-300">
            <Clock className="h-4 w-4 text-secondary" />
            {renderTimeLine()}
          </div>
        </div>
        <div className="flex flex-col items-end gap-2">
          <span className="text-[11px] uppercase tracking-wider px-2 py-1 rounded-md bg-white/5 border border-white/10 text-slate-300">
            {tier === "with_call" ? "Sprint + Call" : "Sprint Self-Service"}
          </span>
          {isCompleted && (
            <span className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-emerald-500/15 border border-emerald-500/30 text-emerald-300">
              <CheckCircle2 className="h-3.5 w-3.5" /> Completato
            </span>
          )}
          {isExpired && !isCompleted && (
            <span className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-amber-500/15 border border-amber-500/30 text-amber-300">
              <AlertTriangle className="h-3.5 w-3.5" /> Scaduto
            </span>
          )}
        </div>
      </div>
      {readOnly && (
        <div className="mt-4 text-xs text-slate-400 border-t border-white/5 pt-3">
          Questo Sprint è in sola lettura. Puoi consultare tutto il lavoro fatto, ma non modificarlo.
        </div>
      )}
    </GlassCard>
  );
}
